import type { AppModule } from '@/app/app-module.types';
import { AlertIcon } from '@/shared/icons';
import { PENDING_ALERTS_ROLES } from './registry/sources';
import { pendingAlertsRoutes } from './presentation/routes';
import { useHasPendingAlerts } from './presentation/hooks/use-has-pending-alerts';

/**
 * Central de Pendências — agregador cross-módulo (Sales, TOTVS e Identity
 * hoje, ver `registry/sources.ts`) de alertas operacionais que ainda pedem
 * decisão humana. Sem `register`: reaproveita os repositórios já registrados
 * pelos módulos de origem (`SalesRepositoryToken`, `TotvsRepositoryToken`,
 * `UsersRepositoryToken`) — a ordem
 * desta lista em `app.module.ts` não importa porque `initModules()` roda o
 * `register` de **todos** os módulos antes de qualquer hook resolver o
 * container.
 */
export const pendingAlertsModule: AppModule = {
  name: 'pending-alerts',

  routes: pendingAlertsRoutes,

  menu: [
    {
      label: 'Central de Pendências',
      to: '/pending-alerts',
      icon: AlertIcon,
      section: 'operations',
      order: 0,
      roles: PENDING_ALERTS_ROLES,
      indicator: { useActive: useHasPendingAlerts, label: 'há pendências' },
    },
  ],
};
